/* Hero Premiom OI : carrousel en fondu sur la colonne image et invitation au scroll.
   Sans JavaScript, la première image reste affichée et le lien de scroll reste inerte. */
if (!customElements.get('premiom-hero-slider')) {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class PremiomHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.premiom-hero__slide')];
      this.dots = [...this.querySelectorAll('.premiom-hero__dot')];
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 6000;
      this.hovered = false;
      this.focused = false;
      if (this.slides.length < 2) return;

      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => {
        this.show(i);
        this.restart();
      }, { signal }));
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.restart(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, { signal });
      this.addEventListener('focusout', () => { this.focused = false; this.restart(); }, { signal });
      document.addEventListener('visibilitychange', () => this.restart(), { signal });
      reducedMotion.addEventListener('change', () => this.restart(), { signal });
      /* Éditeur de thème : sélectionner un bloc affiche l'image correspondante. */
      document.addEventListener('shopify:block:select', event => {
        const i = this.slides.indexOf(event.target);
        if (i === -1) return;
        this.show(i);
        this.stop();
      }, { signal });
      /* Slides différées (data-src) : chargées après l'image LCP, une fois la page chargée. */
      if (document.readyState === 'complete') this.loadDeferred();
      else window.addEventListener('load', () => this.loadDeferred(), { once: true, signal });
      this.restart();
    }

    loadDeferred(slide) {
      const images = slide ? slide.querySelectorAll('img[data-src]') : this.querySelectorAll('img[data-src]');
      images.forEach(img => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.stop();
    }

    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('aria-hidden', !active);
        if (active) {
          this.loadDeferred(slide);
          slide.querySelector('img[loading="lazy"]')?.setAttribute('loading', 'eager');
        }
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      if (reducedMotion.matches || document.hidden || this.hovered || this.focused) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }
  }

  customElements.define('premiom-hero-slider', PremiomHeroSlider);

  /* Invitation au scroll : pointe vers la section suivante et s'efface dès que la page défile. */
  const initScrollCue = () => {
    document.querySelectorAll('.premiom-hero__scroll').forEach(cue => {
      const next = cue.closest('.shopify-section')?.nextElementSibling;
      if (next?.id) cue.href = `#${next.id}`;
      cue.addEventListener('click', event => {
        if (!next) return;
        event.preventDefault();
        next.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
      const update = () => cue.classList.toggle('is-hidden', window.scrollY > 40);
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initScrollCue);
  else initScrollCue();
}
